import React from "react";
import { Feedback } from "../../..";

const defaultVal = {
  reloadOnMove: (feedback: Feedback) => {}
};

export const FeedbackListContext = React.createContext<{
  reloadOnMove: (feedback: Feedback) => void;
}>(defaultVal);
